export default {
  GET_CRE_TEAM_LIST_REQUESTED: 'GET_CRE_TEAM_LIST_REQUESTED',
  GET_CRE_TEAM_LIST_SUCCEEDED: 'GET_CRE_TEAM_LIST_SUCCEEDED',
  GET_CRE_TEAM_LIST_FAILED: 'GET_CRE_TEAM_LIST_FAILED',
};
